"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLoanProductSlug = exports.isFullDateTimeStr = exports.isDateTimeZone = exports.isISO8601Date = exports.isFullDateStr = void 0;
const lodash_1 = __importDefault(require("lodash"));
const finley_types_1 = require("@finley-technologies/finley-types");
const consts_1 = __importDefault(require("../consts"));
const error_1 = require("../error");
const creditAgreementFullArtifact = __importStar(require("./creditAgreementFullArtifact"));
const utils_1 = __importDefault(require("./utils"));
const isBorrowerBankAccountType = (test) => {
    return test && lodash_1.default.includes(lodash_1.default.values(finley_types_1.Bank.BorrowerAccountType), test);
};
const isCapitalProviderBankAccountType = (test) => {
    return test && lodash_1.default.includes(lodash_1.default.values(finley_types_1.Bank.CapitalProviderAccountType), test);
};
const isBankAccountType = (test) => {
    return (test &&
        (isBorrowerBankAccountType(test) || isCapitalProviderBankAccountType(test)));
};
const isBorrowingBaseContributionAccountType = (test) => {
    return test && consts_1.default.borrowingBaseContributionAccountTypes.includes(test);
};
const hasBorrowerKeyForFeature = (borrowerKey, borrowerKeyForFeature) => {
    return lodash_1.default.includes(borrowerKeyForFeature, borrowerKey);
};
const hasCreditFacilitySlugForFeature = (creditFacilitySlug, creditFacilitySlugForFeature) => {
    return lodash_1.default.includes(creditFacilitySlugForFeature, creditFacilitySlug);
};
const isFullDateStr = (dateStr) => {
    return (dateStr &&
        typeof dateStr === 'string' &&
        consts_1.default.regExpFullDateStr.test(dateStr));
};
exports.isFullDateStr = isFullDateStr;
// Within Finley systems, ISO 8601 date is a FullDateStr
// The current type definition for FullDateStr
// The annotated pattern is defined similarly at: https://github.com/finleytechnologies/atlas/blob/development/packages/universal/finley-types/source/types/Utils.ts#L11
// There are minor variances in the format, but do not seem to express themselves differently when tested
const isISO8601Date = (dateString) => {
    // Regular expression to match ISO 8601 date format "yyyy-LL-dd"
    const iso8601Regex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
    // Check if the date string matches the regex
    if (!iso8601Regex.test(dateString)) {
        return false;
    }
    // Parse the date components
    const [year, month, day] = dateString.split('-').map(Number);
    // Create a Date object using the parsed components
    const date = new Date(year, month - 1, day);
    // Check if the Date object represents the same date as the input string
    return (date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day);
};
exports.isISO8601Date = isISO8601Date;
const isDateTimeZone = (tz) => lodash_1.default.includes(lodash_1.default.values(finley_types_1.Util.DateTimeZones), tz);
exports.isDateTimeZone = isDateTimeZone;
const isFullDateTimeStr = (datTimeStr) => {
    return (datTimeStr &&
        typeof datTimeStr === 'string' &&
        consts_1.default.regExpFullDateTimeStr.test(datTimeStr));
};
exports.isFullDateTimeStr = isFullDateTimeStr;
/**
 * see if this is a valid DocxtemplaterError type for our error handling
 * @param err potential error
 * @returns boolean true if typeof error
 */
const isDocxtemplaterErrorType = (err) => {
    return (0, error_1.isErrorType)(err) && 'properties' in err;
};
/**
 * Check whether the error is a Slack webapi platform error type for error handling
 * @param err potential error
 * @returns boolean true if typeof error
 */
const isSlackWebApiPlatformError = (err) => {
    return ((0, error_1.isErrorType)(err) &&
        err.code === 'slack_webapi_platform_error');
};
const isCreditFacilitySlug = (test) => {
    // TODO: backend validation of a valid slug would be ideal.
    return lodash_1.default.isString(test);
};
const isCreditFacilitySlugs = (test) => {
    return lodash_1.default.isArray(test) && lodash_1.default.every(test, isCreditFacilitySlug);
};
const isFundingRequestComponentType = (val) => {
    const types = Object.values(finley_types_1.FundingRequest.FundingRequestComponentType);
    return val && lodash_1.default.includes(types, val);
};
const isFundingRequestGeneralPropertiesOrComponentType = (val) => {
    const types = [
        ...Object.values(finley_types_1.FundingRequest.FundingRequestGeneralPropertiesType),
        ...Object.values(finley_types_1.FundingRequest.FundingRequestComponentType),
    ];
    return val && lodash_1.default.includes(types, val);
};
const isFundingRequestComponent = (obj) => {
    const properties = [
        'id',
        'fundingRequestId',
        'type',
        'amount',
        'sourceBankAccountId',
        'destinationBankAccountId',
        'targetFundingDate',
        'postingDate',
        'borrowerVerifiedTransactionId',
        'borrowerFinancialDataSourceKey',
        'created_at',
        'updated_at',
    ];
    return (utils_1.default.checkAllPropertiesExist({
        obj,
        properties,
        forType: 'FundingRequestComponent',
    }) && isFundingRequestComponentType(obj.type));
};
const isFundingRequest = (obj) => {
    const properties = [
        'borrowingBaseReportId',
        'creditFacilityId',
        'collectionsPaydownTotalAmount',
        'collectionsRecycleTotalAmount',
        'curePaydownTotalAmount',
        'drawRequestTotalAmount',
        'expire',
        'fundingRequestConstraintId',
        'id',
        'isCurrent',
        'status',
        'created_at',
        'updated_at',
    ];
    return utils_1.default.checkAllPropertiesExist({
        obj,
        properties,
        forType: 'FundingRequest',
    });
};
const isInterestRateDataSource = (obj) => {
    return (obj &&
        (obj === 'manual' || obj === 'bloomberg' || obj === 'wsj' || obj === 'ice'));
};
const isBankDataProviderKey = (providerKey) => {
    return lodash_1.default.isNil(consts_1.default.bankDataProviderKeys[providerKey]);
};
const isOrganizationType = (val) => {
    return val && lodash_1.default.includes(lodash_1.default.values(finley_types_1.Organization.OrganizationType), val);
};
const isOrganization = (obj) => {
    return (obj &&
        'id' in obj &&
        'created_at' in obj &&
        'updated_at' in obj &&
        'name' in obj &&
        'type' in obj &&
        isOrganizationType(obj.type) &&
        'slug' in obj);
};
const isBorrowerOrg = (obj) => {
    return obj && isOrganization(obj) && obj.type === 'borrower';
};
const isCapitalProviderOrg = (obj) => {
    return obj && isOrganization(obj) && obj.type === 'capitalProvider';
};
const isLoanProductSlug = (test) => {
    // TODO: backend validation of a valid slug would be ideal.
    return lodash_1.default.isString(test);
};
exports.isLoanProductSlug = isLoanProductSlug;
const isServicerReportProperty = (propertyKey) => {
    return lodash_1.default.includes(Object.values(finley_types_1.Report.ReportXlsxTemplate.ServicerReportProperty), propertyKey);
};
const isDataTapeProperty = (propertyKey) => {
    return lodash_1.default.includes([
        ...Object.values(finley_types_1.Report.ReportXlsxTemplate.LoanProductDataTape),
        ...Object.values(finley_types_1.Report.ReportXlsxTemplate.OtherDataTape),
    ], propertyKey);
};
const isBorrowerEmailType = (test) => {
    return lodash_1.default.includes(lodash_1.default.values(finley_types_1.Notifications.BorrowerEmailType), test);
};
const isBorrowerSlackType = (test) => {
    return lodash_1.default.includes(lodash_1.default.values(finley_types_1.Notifications.BorrowerSlackNotificationType), test);
};
const isCapitalProviderEmailType = (test) => {
    return lodash_1.default.includes(lodash_1.default.values(finley_types_1.Notifications.CapitalProviderEmailType), test);
};
const isWebhookType = (test) => {
    return lodash_1.default.includes(lodash_1.default.values(finley_types_1.Notifications.WebhookType), test);
};
const isValidNotificationSubType = (notificationType, notificationSubType) => (notificationType === 'email' && isBorrowerEmailType(notificationSubType)) ||
    (notificationType === 'email' &&
        isCapitalProviderEmailType(notificationSubType)) ||
    (notificationType === 'slack' && isBorrowerSlackType(notificationSubType)) ||
    (notificationType === 'webhook' && isWebhookType(notificationSubType));
const isStringArray = (obj) => lodash_1.default.isArray(obj) && lodash_1.default.every(obj, (el) => lodash_1.default.isString(el));
const isXlsxTemplateProperty = (test) => {
    return lodash_1.default.keys(finley_types_1.Report.ReportXlsxTemplate.xlsxTemplateProperty).includes(test);
};
function isNotNullOrUndefined(value) {
    return value !== undefined && value !== null;
}
const isBankAccountCashBalance = (obj) => {
    return (obj &&
        'bankAccountId' in obj &&
        'balance' in obj &&
        'accountType' in obj &&
        (isBorrowingBaseContributionAccountType(obj.accountType)
            ? 'cashAdvanceRate' in obj
            : true));
};
const isCashResponseTape = (obj) => {
    return (obj &&
        'creditFacilityId' in obj &&
        'reportingDate' in obj &&
        'fileVersion' in obj &&
        'bankAccountCashBalances' in obj &&
        lodash_1.default.every(obj.bankAccountCashBalances, isBankAccountCashBalance));
};
exports.default = Object.assign(Object.assign({ hasBorrowerKeyForFeature,
    hasCreditFacilitySlugForFeature,
    isBankAccountType,
    isBankDataProviderKey,
    isBorrowerBankAccountType,
    isBorrowerEmailType,
    isBorrowerOrg,
    isBorrowingBaseContributionAccountType,
    isCapitalProviderBankAccountType,
    isCapitalProviderEmailType,
    isCapitalProviderOrg,
    isCashResponseTape,
    isCreditFacilitySlug,
    isCreditFacilitySlugs,
    isDataTapeProperty,
    isDateTimeZone: exports.isDateTimeZone,
    isDocxtemplaterErrorType,
    isErrorType: error_1.isErrorType,
    isFinleyErrorType: error_1.isFinleyErrorType,
    isFullDateStr: exports.isFullDateStr,
    isFullDateTimeStr: exports.isFullDateTimeStr,
    isFundingRequest,
    isFundingRequestComponent,
    isFundingRequestComponentType,
    isFundingRequestGeneralPropertiesOrComponentType,
    isInterestRateDataSource,
    isISO8601Date: exports.isISO8601Date,
    isLoanProductSlug: exports.isLoanProductSlug,
    isNotNullOrUndefined,
    isOrganization,
    isServicerReportProperty,
    isSlackWebApiPlatformError,
    isStringArray,
    isValidNotificationSubType,
    isXlsxTemplateProperty }, utils_1.default), { creditAgreementFullArtifact });
//# sourceMappingURL=index.js.map